import React from 'react';
import LegalPage from '../components/LegalPage';

const FAQ = () => (
  <LegalPage
    title="FAQ"
    description="Answers to common questions about AVbot: setup, modules, data, and troubleshooting."
    file="faq.md"
  />
);

export default FAQ;
